import React, { useState } from "react";
import "./styles.css";
import cerrar from "../../../../static/img/cerrar.svg";

const PlanModal = ({ plan, onClose }) => {
    const [isClosing, setIsClosing] = useState(false);

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            onClose();
        }, 300); 
    };
    return (
            <div
                className={`plan-modal-overlay ${isClosing ? "closing" : ""}`}
                data-testid="plan-modal-overlay">
            <div className="plan-modal">
                <button className="plan-modal-cerrar" onClick={handleClose}>
                    <img src={cerrar} alt="Cerrar" />
                </button>

                <h2 className="plan-modal-title">Detalles</h2>

                <div className="plan-container">
                    <span className="plan-label">Plan</span>
                    <div className="plan-info">
                        <h2 className="plan-name">{plan.nombre}</h2>
                        <p className="plan-price">{plan.monto.toLocaleString()} $</p>
                    </div>
                </div>

                <div className="plan-description-container">
                    <span className="description-label">Descripción:</span>
                    <p className="plan-description">{plan.descripcion}</p>
                </div>
            </div>
        </div>
    );
};

export default PlanModal;
